import styled from 'styled-components'
import { SkeletonStyleProps } from '.'

const defaultEnableAnimation = true

interface ISkeletonWrapperStyleProps extends SkeletonStyleProps {
  circle: boolean
}

export const SkeletonWrapper = styled.span<ISkeletonWrapperStyleProps>`
  --width: ${({ width }) => width ?? '100%'};

  --radius: ${({ borderRadius, circle }) => (circle ? '50%' : borderRadius ?? '0.25rem')};
  --base-color: ${({ baseColor, theme }) => baseColor ?? theme.colors.colorebebeb};
  --highlight-color: ${({ highlightColor, theme }) => highlightColor ?? theme.colors.colorf5f5f5};

  --animation-direction: ${({ animationDirection }) => (animationDirection === 'rtl' ? 'reverse' : 'normal')};
  --animation-duration: ${({ duration }) => (duration ? `${duration}s` : '1.5s')};
  --pseudo-element-display: ${({ enableAnimation = defaultEnableAnimation }) => (enableAnimation ? 'block' : 'none')};

  ${({ height }) => height && `height: ${height};`}

  position: relative;
  width: var(--width);

  display: inline-flex;

  background-color: var(--base-color);
  border-radius: var(--radius);

  line-height: 1;
  user-select: none;
  overflow: hidden;
  z-index: 1;

  &::after {
    content: ' ';
    display: var(--pseudo-element-display);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    background-repeat: no-repeat;
    background-image: linear-gradient(90deg, var(--base-color), var(--highlight-color), var(--base-color));
    transform: translateX(-100%);

    animation-name: react-loading-skeleton;
    animation-direction: var(--animation-direction);
    animation-duration: var(--animation-duration);
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
  }

  @keyframes react-loading-skeleton {
    100% {
      transform: translateX(100%);
    }
  }
`
